"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.debug = debug;
function debug() {
  if (window.__DEBUG__) {
    var _console;

    (_console = console).debug.apply(_console, arguments); 
    return arguments;
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-alice-carousel/lib/utils/debug.js
// module id = 60
// module chunks = 0